'use strict';

function promiseOrCallback(promise, callback) { // eslint-disable-line consistent-return
  if (callback) {
    promise
      .then(function (data) {
        callback(null, data);
      })
      .catch(function (err) {
        callback(err);
      });
  } else {
    return promise;
  }
}

module.exports = promiseOrCallback;



//////////////////
// WEBPACK FOOTER
// ./~/@braintree/wrap-promise/lib/promise-or-callback.js
// module id = 648
// module chunks = 0